import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { loadReport } from "../thunks/loadReportData";
import { PushNotification } from "../types";

export const usePushNotificationsListData = () => {
  const data = useSelector<StoreType, PushNotification[] | undefined>(
    (s) => s.data.reports.pushnotifications.data
  );

  const dispatch = useDispatch();
  const dispatchLoadData = React.useCallback(() => dispatch(loadReport()), [
    dispatch,
  ]);

  return [data, dispatchLoadData] as [typeof data, typeof dispatchLoadData];
};
